import React from "react";
import PropTypes from "prop-types";

import styles from "./Image.module.css";

const Image = ({ data: { src = "", alt = "" } = {} }) => {
  return <img className={styles.image} src={src} alt={alt} />;
};

export default Image;

Image.propTypes = {
  data: PropTypes.object,
};
